import jsonLogic from "json-logic-js";
import { addDays, addMonths, addWeeks, addYears, differenceInDays, differenceInMonths, differenceInWeeks, differenceInYears, format, getDate, isAfter, isBefore, isSameDay, parseISO, setDate, startOfDay, startOfMonth, startOfToday, isEqual, } from "date-fns";
import { notEmpty } from "./operations/notEmpty";
import { noneIn } from "./operations/noneIn";
import { someIn } from "./operations/someIn";
/**
 * Custom operations for json-logic-js.
 */
jsonLogic.add_operation("not_empty", notEmpty);
jsonLogic.add_operation("none_in", noneIn);
jsonLogic.add_operation("some_in", someIn);
/**
 * Date related operations for json-logic-js.
 */
Object.entries({
    addDays,
    addMonths,
    addWeeks,
    addYears,
    differenceInDays,
    differenceInMonths,
    differenceInWeeks,
    differenceInYears,
    format,
    getDate,
    isAfter,
    isBefore,
    isSameDay,
    parseISO,
    setDate,
    startOfDay,
    startOfMonth,
    startOfToday,
    isEqual,
}).forEach(([name, dateOperation]) => {
    jsonLogic.add_operation(name, dateOperation);
});
export { jsonLogic };
